export default __webpack_public_path__ + "static/media/link-dismiss.a64fa41a.svg";